import React from 'react';
import { useTranslation } from 'react-i18next';
import { debounce, find } from 'lodash'

import Grid from '@material-ui/core/Grid';
import Select from '@material-ui/core/Select'
import Checkbox from '@material-ui/core/Checkbox'
import { withStyles } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import MenuItem from '@material-ui/core/MenuItem'
import { Search, ExpandMore } from '@material-ui/icons';
import TextFiled from '@/components/textField';
import { Colors } from '@/theme';
import Button from '@/components/button';
import Paper from '@material-ui/core/Paper';

import { PROMOTION_TYPES, PROMOTION_STATUSES } from '../helper'
import useStyles from './styles';

const FormHeader = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const {
    promotionTypes,
    promotionStatuses,
    onChangePromotionTypes,
    onChangePromotionStatuses,
    onChangeSearch,
    onAdd
  } = props

  return (
    <Grid item xs={12}>
      <Paper style={{ width: '100%' }}>
        <Grid
          container
          alignItems='center'
          spacing={2}
          className={classes.paperContent}
        >
          <Grid item xs={12} sm={4} lg={4}>
            <TextFiled
              placeholder={t('promotions.enter_promotion_name')}
              className={classes.searchInput}
              onChange={debounce((e) => onChangeSearch(e.target.value), 1000)}
              startAdornment={
                <Search
                  style={{ color: Colors.GRAY_BORDER1 }}
                  width={18}
                  height={18}
                />
              }
            />
          </Grid>

          <Grid item xs={12} sm={4} lg={2} style={{ padding: '4px 12px' }}>
            <Select
              multiple
              disableUnderline
              IconComponent={ExpandMore}
              displayEmpty
              renderValue={() => promotionTypes.length === PROMOTION_TYPES.length
                ? t('promotions.all_types')
                : promotionTypes.map(item => item.name).join(', ')
              }
              fullWidth
              className={classes.filterInput}
              value={promotionTypes}
              onChange={(event) => onChangePromotionTypes(event.target.value)}
              inputProps={{ 'aria-label': 'Without label' }}
            >
              {PROMOTION_TYPES.map((item, id) => (
                <MenuItem key={`order-payment-state-${id}`} value={item}>
                  <GreenCheckbox
                    color='default'
                    checked={!!find(promotionTypes, { type: item.type })}
                    size='small'
                  />
                  <Typography className={classes.titleText}>
                    {item.name}
                  </Typography>
                </MenuItem>
              ))}
            </Select>
          </Grid>

          <Grid item xs={12} sm={4} lg={2} style={{ padding: '4px 12px' }}>
            <Select
              multiple
              disableUnderline
              IconComponent={ExpandMore}
              displayEmpty
              renderValue={() => promotionStatuses.length === PROMOTION_STATUSES.length
                ? t('promotions.all_promotions')
                : promotionStatuses.map(item => item.name).join(', ')
              }
              fullWidth
              className={classes.filterInput}
              value={promotionStatuses}
              onChange={(event) => onChangePromotionStatuses(event.target.value)}
              inputProps={{ 'aria-label': 'Without label' }}
            >
              {PROMOTION_STATUSES.map((item, id) => (
                <MenuItem key={`order-state-${id}`} value={item}>
                  <GreenCheckbox
                    color='default'
                    checked={!!find(promotionStatuses, { status: item.status })}
                    size='small'
                  />
                  <Typography className={classes.titleText}>
                    {item.name}
                  </Typography>
                </MenuItem>
              ))}
            </Select>
          </Grid>

          <Grid item xs={12} sm={8} lg={4}>
            <Grid container justify="flex-end">
              <Button
                className={classes.addButton}
                color="primary"
                variant="contained"
                onClick={onAdd}
              >
                {t('button_group.add_new')}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
};

const GreenCheckbox = withStyles({
  root: {
    color: '#979797',
    '&$checked': {
      color: '#55CC66',
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

export default FormHeader;